import { createContext, useContext, useMemo, ReactNode } from 'react';

import { useLoadIntermediateScript } from './hooks/useLoadIntermediateScript';

interface GoogleIntermediateContextProps {
    scriptLoadedSuccessfully: boolean;
}

const GoogleIntermediateContext = createContext<GoogleIntermediateContextProps>(null!);

interface GoogleIntermediateProviderProps {
    children: ReactNode;
}

export function GoogleIntermediateProvider({ children }: GoogleIntermediateProviderProps) {
    const scriptLoadedSuccessfully = useLoadIntermediateScript();

    const contextValue = useMemo(
        () => ({
            scriptLoadedSuccessfully,
        }),
        [scriptLoadedSuccessfully]
    );

    return (
        <GoogleIntermediateContext.Provider value={contextValue}>
            {children}
        </GoogleIntermediateContext.Provider>
    );
}

export function useGoogleIntermediate() {
    const context = useContext(GoogleIntermediateContext);
    if (!context) {
        throw new Error(
            'Google intermediate components must be used within GoogleIntermediateProvider'
        );
    }
    return context;
}
